import axios from "axios";
import { CrudService } from "../crud.service";
import { environment } from "../../environments/environment";
import LocalStorageKeys from "../../data/localStorageKeys";
import { ApiService } from "../api.service";
import { EnumEstadosBeneficios } from "../../constants/beneficio.constants";

export class BeneficioAdministradorService extends CrudService {
    estado = EnumEstadosBeneficios.APROBADO;

    get AuthHeader() {
        return "Token " + localStorage.getItem(LocalStorageKeys.token);
    }

    /**
     * 
     * @param {Function} funcionDto función que convierte de entidad a dto, usada al editar o crear. Si no se pasa una, se enviará la entidad completa al editar o crear
     * @param {Function} funcionEntidad función que convierte de dto a entidad, usada al traer la lista. La lista quedará con los dtos sin tocar si no se pasa una
     * @param {Boolean} estado Si es pendiente, las listas vienen solo con beneficios pendientes (no aprobados por administradores aún)
     */
    constructor(funcionDto, funcionEntidad, estado = EnumEstadosBeneficios.APROBADO) {
        super('admin/beneficio/', funcionDto, funcionEntidad);

        this.estado = estado;
    }

    aprobar(beneficio) {
        const path = `${CrudService.api}${this.endPoint}${beneficio.id}/aprobar`;
        return axios.put(path, {}, { headers: this.Headers });
    }

    rechazar(beneficio) {
        const path = `${CrudService.api}${this.endPoint}${beneficio.id}/rechazar`;
        return axios.put(path, {}, { headers: this.Headers });
    }

    /**
         * Cantidad de beneficios
         * @param {object} busqueda Objeto busqueda
         * @param {string} idComercio id del comercio
         * @param {number} subcategoria id de subcategoria
         * */
    countWithFilter({ busqueda = undefined, idComercio = undefined, subcategoria = undefined }) {
        const dto = {
            busqueda,
            idComercio,
            subcategoria,
            estado: this.estado
        };

        const path = ApiService.api + this.endPoint + 'filter/count';

        return axios
            .post(path,
                dto,
                { headers: { Authorization: this.AuthHeader } }
            );
    }

    /**
         * Todos los beneficios que existen
         * @param {number} desde Inicio de página
         * @param {number} hasta Fin de página 
         * @param {object} busqueda Objeto búsqueda
         * @param {number} subcategoria id de subcategoria
         * */
    getTodos({ desde = 1, hasta = 20, busqueda = undefined, idComercio = undefined, subcategoria = undefined }) {
        const filterDto = {
            busqueda,
            desde,
            hasta,
            idComercio,
            subcategoria,
            estado: this.estado
        };

        return axios
            .post(
                ApiService.api + this.endPoint + "filter/",
                filterDto,
                { headers: { Authorization: this.AuthHeader } });
    }

    /**
         * 
         * @param {Object} beneficio IBeneficioEditDto
         * @returns {Promise<import("axios").AxiosResponse<Object>>} Beneficio creado, de tipo IBeneficioPanelDto
         */
    crear(beneficio) {
        return axios
            .post(environment.API_URL + this.endPoint, beneficio,
                { headers: { Authorization: this.AuthHeader } });
    }

    guardar(beneficio) {
        return axios
            .put(environment.API_URL + this.endPoint, beneficio,
                { headers: { Authorization: this.AuthHeader } });
    }

    eliminar(id) {
        return axios
            .delete(environment.API_URL + this.endPoint + id,
                { headers: { Authorization: this.AuthHeader } });
    }

    getTiposDescuento() {
        return axios
            .get(environment.API_URL + "tiposdescuentos/",
                { headers: { Authorization: this.AuthHeader } });
    }

}